<template>
  <el-dialog
    :model-value="modelValue"
    title="Asociación y Distribución de Productos"
    width="70%"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="!isSaving"
    custom-class="modal-asociacion"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <div
      v-loading="isSaving"
      element-loading-text="Guardando asociaciones y generando productos..."
    >
      <el-alert
        title="¡Atención! Faltan productos terminados"
        type="warning"
        description="Asigne los productos y distribuya las cantidades correspondientes para alcanzar el total aprobado."
        show-icon
        :closable="false"
        style="margin-bottom: 20px"
      />

      <div
        style="
          margin-bottom: 15px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <h3 style="margin: 0; color: #303133">Distribuir Cantidades</h3>
        <el-tag
          :type="sumatoriaAsignada === cantidadTotalAprobada ? 'success' : 'danger'"
          effect="dark"
          size="large"
        >
          Total Asignado: {{ sumatoriaAsignada }} / {{ cantidadTotalAprobada }}
        </el-tag>
      </div>

      <div
        v-for="(item, index) in orphanItems"
        :key="index"
        class="orphan-card"
      >
        <div class="card-header">
          <div class="item-info">
            <span class="item-badge">Ítem {{ item.ItemProducto }}</span>

            <el-input-number
              ref="inputRef"
              v-model="item.Cantidad"
              :min="0"
              :formatter="formatter"
              :parser="parser"
              size="small"
              style="width: 130px; margin-right: 10px"
              @focus="handleFocus"
              @blur="handleBlur(item.Cantidad)"
            />

            <span class="item-desc">{{ item.DescripcionOriginal || 'Nuevo ítem derivado' }}</span>
          </div>

          <div
            class="item-status"
            style="display: flex; align-items: center; gap: 10px"
          >
            <el-button
              v-if="item.CodigoFilCotizacionProducto === 0"
              type="danger"
              plain
              size="small"
              @click="eliminarItem(index)"
            >
              Eliminar
            </el-button>

            <el-tag
              v-if="item.AsociacionLista"
              type="success"
              effect="dark"
            >
              <i class="el-icon-check"></i> Listo para asociar
            </el-tag>
            <el-tag
              v-else
              type="danger"
              effect="plain"
            >
              Falta asociar
            </el-tag>
          </div>
        </div>

        <div class="card-body">
          <div
            v-if="item.Modo === null"
            class="action-buttons"
          >
            <el-button
              type="primary"
              plain
              @click="openSearchDrawer(index)"
            >
              <icon-search /> Buscar Existente
            </el-button>
            <span class="o-divider">o</span>
            <el-button
              type="success"
              plain
              @click="setModo(index, 'nuevo')"
            >
              <icon-add /> Alta Producto
            </el-button>
          </div>

          <div
            v-if="item.Modo === 'existente'"
            class="selected-product-box"
          >
            <div
              class="product-details"
              style="line-height: 1.5"
            >
              <div>
                <strong>Producto Seleccionado:</strong>
                {{ item.CodigoProductoSeleccionado }} - {{ item.DescripcionSeleccionada }}
              </div>
              <div style="font-size: 15px; color: #606266; margin-top: 4px">
                <span style="margin-right: 15px">
                  <strong>Cód. Equivalente:</strong> {{ item.CodigoEquivalenteSeleccionado || '-' }}
                </span>
                <span style="margin-right: 15px">
                  <strong>Cód. Secundario:</strong> {{ item.CodigoAdicionalSeleccionado || '-' }}
                </span>
                <span>
                  <strong>ET:</strong>
                  <el-tag
                    size="default"
                    type="info"
                    style="margin-left: 4px"
                  >
                    {{ item.CodigoETSeleccionada || 'Sin ET' }}
                  </el-tag>
                </span>
              </div>
            </div>
            <el-button
              size="small"
              type="danger"
              plain
              @click="clearSelection(index)"
            >
              Cambiar
            </el-button>
          </div>

          <div
            v-if="item.Modo === 'nuevo'"
            class="quick-create-box"
          >
            <el-row
              :gutter="15"
              align="middle"
              style="margin-bottom: 15px"
            >
              <el-col :span="14">
                <div class="custom-label">
                  Descripción del nuevo producto <span style="color: red">*</span>
                </div>
                <el-input
                  v-model="item.NuevaDescripcion"
                  placeholder="Descripción comercial..."
                />
              </el-col>
              <el-col :span="8">
                <div class="custom-label">Unidad de Medida <span style="color: red">*</span></div>
                <el-select
                  v-model="item.NuevaUnidadMedida"
                  placeholder="Unidad"
                  style="width: 100%"
                >
                  <el-option
                    v-for="um in unidadesMedida"
                    :key="um.Codigo"
                    :label="um.Descripcion"
                    :value="um.Codigo"
                  />
                </el-select>
              </el-col>
            </el-row>

            <el-row
              :gutter="15"
              align="middle"
            >
              <el-col :span="10">
                <div class="custom-label">Código Equivalente</div>
                <el-input
                  v-model="item.NuevaCodigoEquivalente"
                  placeholder="Opcional..."
                />
              </el-col>
              <el-col :span="10">
                <div class="custom-label">Código Adicional</div>
                <el-input
                  v-model="item.NuevaCodigoAdicional"
                  placeholder="Opcional..."
                />
              </el-col>
              <el-col
                :span="4"
                style="text-align: right; margin-top: 15px"
              >
                <el-button
                  size="small"
                  type="info"
                  plain
                  @click="clearSelection(index)"
                >
                  Cancelar
                </el-button>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>

      <el-button
        type="dashed"
        style="width: 100%; margin-bottom: 10px"
        @click="agregarNuevoItem"
      >
        <icon-add /> Agregar otro producto
      </el-button>
    </div>

    <template #footer>
      <div style="display: flex; justify-content: space-between; align-items: center; width: 100%">
        <div
          style="
            color: #f56c6c;
            font-size: 13px;
            display: flex;
            align-items: center;
            gap: 8px;
            text-align: left;
          "
        >
          <IconAlert :size="18"></IconAlert>
          <span>La cotización no podra editarse luego de guardar los productos.</span>
        </div>

        <div class="dialog-footer">
          <el-button
            :disabled="isSaving"
            @click="onCancel"
            >Cancelar</el-button
          >
          <el-button
            type="primary"
            :disabled="!isFormValid || isSaving"
            @click="confirmarConAdvertencia"
          >
            Confirmar y Aprobar Propuesta
          </el-button>
        </div>
      </div>
    </template>

    <InputProductosTerminadosDrawer
      v-if="isDrawerVisible"
      :visible="isDrawerVisible"
      :clientes="clientesArray"
      :codigoElementoGrupo="null"
      :et-recomendada="etDetectada"
      :codigos-ya-seleccionados="codigosEnModal"
      @select-poducto="handleProductSelectedFromDrawer"
      @close-drawer="isDrawerVisible = false"
    />
  </el-dialog>
</template>

<script setup>
import {
  ref,
  computed,
  onMounted,
} from 'vue';
import { storeToRefs } from 'pinia';
import {
  ElNotification,
  ElMessageBox,
} from 'element-plus';
import IconSearch from '~icons/mdi/search';
import IconAdd from '~icons/mdi/add';
import IconAlert from '~icons/mdi/alert-octagon-outline';
import InputProductosTerminadosDrawer from '@/shared/components/input_productos_terminados_drawer.vue';
import { useLocaleNumberInput } from '@/shared/composables/useLocaleNumberInput.js';

import { buildMaterialRapidoPayload } from '@/shared/utils/material_rapido.js';
import { useUnidadMedidaStore } from '@/stores/unidad_medida/unidad_medida_store';
import { useMaterialStore } from '@/stores/materiales_store';
import { usePricesStore } from '@/views/prices/stores/prices_store';

const { inputRef, formatter, parser, handleFocus, handleBlur } = useLocaleNumberInput(null);

const props = defineProps({
  modelValue: { type: Boolean, required: true },
  cotizacion: { type: Object, required: true },
  cliente: { type: Object, required: true },
  cantidadTotalAprobada: { type: Number, required: true },
  itemCantidadAprobada: { type: Number, required: true },
});

const sumatoriaAsignada = computed(() => {
  return orphanItems.value.reduce((acc, item) => acc + (Number(item.Cantidad) || 0), 0);
});

const emit = defineEmits(['update:modelValue', 'on-success']);

const unidadMedidaStore = useUnidadMedidaStore();
const materialStore = useMaterialStore();
const pricesStore = usePricesStore();

const { unidadesMedida } = storeToRefs(unidadMedidaStore);

const orphanItems = ref([]);
const isSaving = ref(false);

// Variables para el Drawer
const isDrawerVisible = ref(false);
const currentItemIndex = ref(-1); // Saber a que item le estamos buscando producto

const clientesArray = computed(() => {
  return props.cliente?.Codigo ? [props.cliente.Codigo] : [];
});

onMounted(async () => {
  const productos = props.cotizacion?.CotizacionProducto || [];
  const itemsHuerfanos = productos.filter((p) => !p.CodigoProducto);

  if (itemsHuerfanos.length > 0) {
    orphanItems.value = itemsHuerfanos.map((item) => ({
      CodigoFilCotizacionProducto: item.Codigo,
      ItemProducto: item.ItemProducto,
      Cantidad: item.Cantidad,
      DescripcionOriginal: item.Descripcion,
      Modo: null,
      AsociacionLista: false,
      CodigoProductoSeleccionado: null,
      DescripcionSeleccionada: '',
      NuevaDescripcion: item.Descripcion,
      CodigoEquivalenteSeleccionado: '',
      CodigoAdicionalSeleccionado: '',
      NuevaUnidadMedida: props.cotizacion.CodigoUnidadVenta,
      NuevaCodigoEquivalente: '',
      NuevaCodigoAdicional: '',
    }));
  } else {
    orphanItems.value.push({
      CodigoFilCotizacionProducto: 0,
      ItemProducto: 1,
      Cantidad: props.cantidadTotalAprobada,
      DescripcionOriginal: 'Nuevo ítem derivado',
      Modo: null,
      AsociacionLista: false,
      CodigoProductoSeleccionado: null,
      DescripcionSeleccionada: '',
      NuevaDescripcion: props.cotizacion.Referencia || '',
      CodigoEquivalenteSeleccionado: '',
      CodigoAdicionalSeleccionado: '',
      NuevaUnidadMedida: props.cotizacion.CodigoUnidadVenta,
      NuevaCodigoEquivalente: '',
      NuevaCodigoAdicional: '',
    });
  }

  if (unidadesMedida.value.length === 0) {
    await unidadMedidaStore.findAllUnidadMedidaHTTP({ page: 0, Activo: true });
  }
});

const etDetectada = computed(() => {
  if (!orphanItems.value || orphanItems.value.length === 0) return null;

  const productoConET = orphanItems.value.find(
    (p) => p.CodigoETBaseSeleccionada || p.CodigoETSeleccionada,
  );
  if (!productoConET) return null;
  return productoConET.CodigoETBaseSeleccionada || productoConET.CodigoETSeleccionada;
});

const codigosEnModal = computed(() => {
  return orphanItems.value
    .filter((item) => item.CodigoProductoSeleccionado)
    .map((item) => `${item.CodigoProductoSeleccionado}-${item.CodigoETSeleccionada || 'null'}`);
});

const setModo = (index, modo) => {
  orphanItems.value[index].Modo = modo;
  actualizarEstadoLista(index);
};

const clearSelection = (index) => {
  const item = orphanItems.value[index];
  item.Modo = null;
  item.CodigoProductoSeleccionado = null;
  item.DescripcionSeleccionada = '';
  item.CodigoETSeleccionada = null;
  item.CodigoEquivalenteSeleccionado = '';
  item.CodigoAdicionalSeleccionado = '';
  actualizarEstadoLista(index);
};

const openSearchDrawer = (index) => {
  currentItemIndex.value = index;
  isDrawerVisible.value = true;
};

const handleProductSelectedFromDrawer = (producto) => {
  if (currentItemIndex.value >= 0) {
    const item = orphanItems.value[currentItemIndex.value];
    item.Modo = 'existente';
    item.CodigoProductoSeleccionado = producto.CodigoProducto || producto.Codigo;
    item.DescripcionSeleccionada = producto.Descripcion || producto.DescripcionComercial;
    item.CodigoETSeleccionada = producto.CodigoET;
    item.CodigoETBaseSeleccionada = producto.CodigoBase || producto.CodigoET;
    item.CodigoEquivalenteSeleccionado = producto.CodigoEquivalente;
    item.CodigoAdicionalSeleccionado = producto.CodigoAdicional;

    actualizarEstadoLista(currentItemIndex.value);
  }
  isDrawerVisible.value = false;
  currentItemIndex.value = -1;
};

// Verifica si la fila ya tiene lo mínimo necesario para ser procesada
const actualizarEstadoLista = (index) => {
  const item = orphanItems.value[index];
  if (item.Modo === 'existente' && item.CodigoProductoSeleccionado) {
    item.AsociacionLista = true;
  } else if (item.Modo === 'nuevo' && item.NuevaDescripcion && item.NuevaUnidadMedida) {
    item.AsociacionLista = true;
  } else {
    item.AsociacionLista = false;
  }
};

const agregarNuevoItem = () => {
  const nuevoItemNumero = orphanItems.value.length + 1;
  orphanItems.value.push({
    CodigoFilCotizacionProducto: 0,
    ItemProducto: nuevoItemNumero,
    Cantidad: 0,
    DescripcionOriginal: 'Nuevo ítem',
    Modo: null,
    AsociacionLista: false,
    CodigoProductoSeleccionado: null,
    DescripcionSeleccionada: '',
    NuevaDescripcion: '',
    CodigoEquivalenteSeleccionado: '',
    CodigoAdicionalSeleccionado: '',
    NuevaUnidadMedida: props.cotizacion.CodigoUnidadVenta,
    NuevaCodigoEquivalente: '',
    NuevaCodigoAdicional: '',
  });
};

const eliminarItem = (index) => {
  orphanItems.value.splice(index, 1);

  orphanItems.value.forEach((item, i) => {
    item.ItemProducto = i + 1;
  });

  if (orphanItems.value.length > 0) {
    actualizarEstadoLista(Math.min(index, orphanItems.value.length - 1));
  }
};

const isFormValid = computed(() => {
  orphanItems.value.forEach((_, i) => actualizarEstadoLista(i));
  const todosListos = orphanItems.value.every((item) => item.AsociacionLista);
  const sumatoriaCorrecta = sumatoriaAsignada.value === props.cantidadTotalAprobada;

  return todosListos && sumatoriaCorrecta;
});

const onCancel = () => {
  emit('update:modelValue', false);
};

const confirmarConAdvertencia = () => {
  const listadoProductos = orphanItems.value
    .map((item) => {
      let descripcionHTML = '';

      if (item.Modo === 'existente') {
        descripcionHTML = `
        <b>${item.DescripcionSeleccionada}</b>
        <span style="font-size: 12px; color: #606266; margin-left: 5px;">
          - Cód. Eq: ${item.CodigoEquivalenteSeleccionado || '-'}
          - Cód. Sec: ${item.CodigoAdicionalSeleccionado || '-'}
          - ET: <b>${item.CodigoETSeleccionada || 'Sin ET'}</b>
        </span>`;
      } else {
        const codEqStr = item.NuevaCodigoEquivalente
          ? ` - Cód. Eq: ${item.NuevaCodigoEquivalente}`
          : '';
        const codSecStr = item.NuevaCodigoAdicional
          ? ` - Cód. Sec: ${item.NuevaCodigoAdicional}`
          : '';

        descripcionHTML = `<i>NUEVO PRODUCTO:</i> <b>${item.NuevaDescripcion}</b> <span style="font-size: 12px; color: #606266; margin-left: 5px;">${codEqStr}${codSecStr}</span>`;
      }

      return `<li style="margin-bottom: 8px; line-height: 1.4;">
              <span style="color: #409EFF; font-weight: bold; display: inline-block; min-width: 80px;">
                ${item.Cantidad} unid.
              </span>
              ➔ ${descripcionHTML}
            </li>`;
    })
    .join('');

  ElMessageBox.confirm(
    `<div style="font-size: 14px; line-height: 1.5; text-align: left;">
      <p>Está a punto de vincular los siguientes productos y <b>aprobar la propuesta</b>:</p>

      <ul style="list-style-type: none; padding-left: 10px; background-color: #f8f9fa; padding: 12px; border-radius: 6px; border: 1px solid #ebeef5;">
        ${listadoProductos}
      </ul>

      <p style="color: #F56C6C; font-weight: bold; margin-top: 15px;">
        <i class="el-icon-warning-outline"></i> Revise la informacion, una vez cargada no podrá modificar estos productos.
      </p>
      <p style="margin-top: 10px;">¿Confirma que la distribución y los productos son correctos?</p>
    </div>`,
    'Confirmación de Aprobación',
    {
      dangerouslyUseHTMLString: true,
      confirmButtonText: 'Sí, Aprobar Definitivamente',
      cancelButtonText: 'Revisar nuevamente',
      type: 'warning',
      customClass: 'message-box-confirmacion',
    },
  )
    .then(() => {
      onConfirm();
    })
    .catch(() => {});
};

const onConfirm = async () => {
  try {
    isSaving.value = true;
    const payloadActualizacionCotizacion = [];

    for (const item of orphanItems.value) {
      let finalCodigoProducto = null;

      if (item.Modo === 'existente') {
        finalCodigoProducto = item.CodigoProductoSeleccionado;
      } else if (item.Modo === 'nuevo') {
        const nuevoMaterialPayload = buildMaterialRapidoPayload({
          descripcion: item.NuevaDescripcion,
          codigoUnidadMedida: item.NuevaUnidadMedida,
          codigoEquivalente: item.NuevaCodigoEquivalente,
          codigoAdicional: item.NuevaCodigoAdicional,
          clientes: [props.cliente.Codigo],
        });
        const response = await materialStore.createMaterialRapidoHTTP(nuevoMaterialPayload);
        finalCodigoProducto = response?.Codigo || response?.data?.Codigo;
      }

      payloadActualizacionCotizacion.push({
        Codigo: item.CodigoFilCotizacionProducto,
        CodigoProducto: String(finalCodigoProducto),
        ItemProducto: item.ItemProducto,
        Descripcion: item.DescripcionOriginal,
        Cantidad: item.Cantidad,
        CodigoEspecificacionTecnica: item.CodigoETSeleccionada || null,
      });
    }

    await pricesStore.vincularProductosTerminadosHTTP(
      props.cotizacion.Codigo,
      payloadActualizacionCotizacion,
      props.itemCantidadAprobada,
    );

    ElNotification({
      title: 'Productos Asociados',
      message: 'Los productos se han vinculado correctamente a la cotización.',
      type: 'success',
    });

    emit('on-success', payloadActualizacionCotizacion);
  } catch (error) {
    console.error(error);
    ElNotification({ title: 'Error', message: 'Error al asociar los productos.', type: 'error' });
  } finally {
    isSaving.value = false;
  }
};
</script>

<style scoped>
.orphan-card {
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  margin-bottom: 15px;
  overflow: hidden;
  background-color: #fff;
}

.card-header {
  background-color: #f8f9fa;
  padding: 12px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e4e7ed;
}

.item-info {
  display: flex;
  align-items: center;
  gap: 15px;
}

.item-badge {
  background-color: #409eff;
  color: white;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: bold;
}

.item-qty {
  font-weight: bold;
  color: #606266;
}

.item-desc {
  color: #909399;
  font-style: italic;
}

.card-body {
  padding: 15px;
}

.action-buttons {
  display: flex;
  align-items: center;
  gap: 15px;
}

.o-divider {
  color: #c0c4cc;
  font-size: 14px;
}

.selected-product-box {
  background-color: #f0f9eb;
  border: 1px solid #e1f3d8;
  padding: 10px 15px;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.product-details {
  color: #67c23a;
}

.quick-create-box {
  background-color: #ecf5ff;
  border: 1px solid #d9ecff;
  padding: 15px;
  border-radius: 4px;
}

.custom-label {
  font-size: 12px;
  font-weight: bold;
  color: #606266;
  margin-bottom: 5px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
<style>
.message-box-confirmacion {
  width: 700px !important;
  max-width: 90vw !important;
}

.message-box-confirmacion .el-message-box__content {
  font-size: 14px;
}
</style>
